import { TextField, type TextFieldProps } from '@mui/material'
import {
  type Control,
  Controller,
  type FieldValues,
  type Path,
} from 'react-hook-form'
import InputMask from 'react-input-mask'

interface FormInputProps<T extends FieldValues>
  extends Omit<TextFieldProps, 'name'> {
  control: Control<T>
  name: Path<T>
  mask?: string
}

export const FormInput = <T extends FieldValues>({
  control,
  name,
  mask = '',
  disabled,
  onBlur,
  ...props
}: FormInputProps<T>) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, formState }) => {
        const { ref, ...restField } = field
        if (mask) {
          return (
            <InputMask
              mask={mask}
              {...restField}
              onBlur={onBlur ?? field.onBlur}
              disabled={disabled}
            >
              {(inputProps: unknown) => (
                <TextField
                  {...props}
                  {...(inputProps as Record<string, unknown>)}
                  inputRef={ref}
                  variant="outlined"
                  fullWidth
                  error={!!formState.errors[name]}
                  helperText={
                    formState.errors[name]?.message as string | undefined
                  }
                />
              )}
            </InputMask>
          )
        }
        return (
          <TextField
            {...props}
            {...restField}
            inputRef={ref}
            variant="outlined"
            fullWidth
            error={!!formState.errors[name]}
            helperText={formState.errors[name]?.message as string | undefined}
          />
        )
      }}
    />
  )
}
